<template>
  <div id="searchBar" v-show="activeView!='persona-detail'" @click="closeFilterPane($event)">
  
    <div id="personaSearchPanel" class="d-flex justify-content-start" :style="{'left': navbarCollapsed ? '200px' : '1rem'}">
      <div id="searchLine1" class="d-inline-block" style="width: 265px;">
        <div class="dropdown mr-2">
          <input type="hidden" :value="filterEmail" id="email_lookup" />
          <span class="glyphicons glyphicons-search input-icon-left text-muted mt-0" style="left: 10px; top: 5px"></span>
          <input type="text" 
            id="txt_persona"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="form-control primary-control" 
            :class="{'is-invalid': invalidPersona && !isPrimarySearch}"
            autocomplete="off" :value="currentPersona.name" 
            placeholder="Choose a persona..." 
            @keyup.delete="function() {clearPersona();}" 
            readonly
          />
          <div class="invalid-tooltip">No lookup persona selected</div>
          <ul class="dropdown-menu">
            <template v-for="(item,idx) in personas">
            <li 
              class="dropdown-item" 
              :class="{'active': currentPersona.id==item.id}"
              @click="setPersona(item)"
            >
              {{item.name}}
              <div class="small font-weight-light"><small>{{item.description}}</small></div>
            </li>
            </template>
          </ul>
          <div v-show="personaActive" class="btn-reset" data-toggle="tooltip" title="Clear search">
            <div @click.stop="resetSearch()"><span class="glyphicons glyphicons-remove"></span></div>
          </div>
          <div class="btn-filter" data-toggle="tooltip" title="Show more search options">
            <div data-toggle="collapse" 
              data-target="#filterPane" 
              @click.prevent="" class=""><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"viewBox="0 0 16 16"><path fill-rule="evenodd" d="M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5ZM12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5ZM1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8Zm9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5Zm1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z"/></svg></div>
          </div>
        </div>
      </div>
      <div class="ml-2 d-inline-block flex-grow-1 pt-1">
        <form v-on:keyup.enter.stop="function(){doSearch()}" autocomplete="off" class="form-inline campaign-filter-form" role="search" id="frmFilters" name="filters" novalidate>
          <!-- date -->
          <div class="mr-md-2 date-input-container d-none d-lg-inline-block" data-toggle="tooltip" title="Range of dates to search">
            <span class="glyphicons glyphicons-calendar input-icon-left text-muted small" style="top:2px; padding-left: 2px;"></span>
            <input class="form-control tiny-nav-btn dateRangePicker date-input-filter date-filter-control" id="date_filter" autocomplete="off" placeholder="Specify date range"/>
          </div>
          <!-- /date -->

          <div v-if="false" v-cloak class="dropdown mr-2 d-none d-lg-inline-block" style="max-width: 150px;">
            <input type="hidden" :value="filterEmail" id="email_lookup" />
            <span class="glyphicons glyphicons-filter input-icon-left text-muted small" style="top:2px; padding-left: 2px;"></span>
            <input type="text" 
              id="txt_filter"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="form-control tiny-nav-btn" 
              autocomplete="off" :value="filterCampaignDisplayText" 
              placeholder="Campaign filters" 
              @keyup.delete="function() {search.filterCampaign=null; search.filterCampaignType=null;}" 
              readonly
            />
            <ul class="dropdown-menu">
              <li class="dropdown-item"
                @click="search.filterCampaign=null; search.filterCampaignType=null"
                :class="{'active': search.filterCampaign==null && search.filterCampaignType==null}"
                >No Filter</li>
              <li role="separator" class="dropdown-divider"></li>
              <div class="dropdown-group" style="max-height: calc(100vh - 200px)">
                <li class="dropdown-header">Campaign Type</li>
                <li class="dropdown-item"
                  @click="search.filterCampaignType='purpose'; search.filterCampaign='Promotional';"
                  :class="{'active': search.filterCampaign=='Promotional' && search.filterCampaignType=='purpose'}"
                  >Promotional</li>
                <li class="dropdown-item"
                  @click="search.filterCampaignType='purpose'; search.filterCampaign='Transactional';"
                  :class="{'active': search.filterCampaign=='Transactional' && search.filterCampaignType=='purpose'}"
                  >Transactional</li>
                <template v-if="marketingPrograms.length">
                  <li role="separator" class="dropdown-divider"></li>
                  <li class="dropdown-header">Marketing Program</li>
                  <li
                    class="dropdown-item"
                    v-for="(item,idx) in marketingPrograms"
                    @click="search.filterCampaignType='marketing_program'; search.filterCampaign=item;"
                    :class="{'active': search.filterCampaign==item && search.filterCampaignType=='marketing_program'}"
                  >
                    {{item}}
                  </li>
                </template>
                <template v-if="marketingStrategies.length">
                  <li role="separator" class="dropdown-divider"></li>
                  <li class="dropdown-header">Marketing Strategy</li>
                  <li
                    class="dropdown-item"
                    v-for="(item,idx) in marketingStrategies"
                    @click="search.filterCampaignType='marketing_strategy'; search.filterCampaign=item;"
                    :class="{'active': search.filterCampaign==item && search.filterCampaignType=='marketing_strategy'}"
                  >
                    {{item}}
                  </li>
                </template>
              </div>
            </ul>

          </div>

          <div class="align-text-baseline d-none d-md-inline-block">
            <div class="custom-control custom-switch d-inline-block">
              <input type="checkbox" class="custom-control-input" id="chkJourney" v-model="viewJourney">
              <label class="custom-control-label" for="chkJourney" id="lblJourney">
                Show Customer Journey</label>
            </div>                        
          </div>
        </form>
      </div>


    </div>
    <div id="filterPane" class="collapse collapsed">
      <div id="filterPaneChild">
      <form v-on:keyup.enter.stop="function(){doSearch(true)}" 
        id="frmFilterPane"
        autocomplete="off" role="search" class="m-0 px-3 pb-3 pt-0" novalidate>
        <div>
          <div class="pt-2 small text-muted d-inline-block" style="font-weight: 600">Search Filters</div>
          <button type="button" class="close" aria-label="Close" @click="closeFilterPane()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- subject -->
        <div class="mt-2 mb-2 mb-2">
          <input
            type="text"
            class="form-control material-control"
            id="filterDropDownInputText"
            placeholder="Subject line keywords"
            v-model="search.subject_keywords"
            autocomplete="off"
            @keyup.delete="function() {search.subject_keywords=null;}"
          />
        </div>
        <!-- subject -->

        <!-- date -->
        <div class="mt-2 mt-sm-0 mb-2 date-input-container d-lg-none" >
          <span class="glyphicons glyphicons-calendar input-icon-left text-muted mt-0"></span>
          <input class="form-control material-control dateRangePicker date-filter-control" id="date_filter2" autocomplete="off" placeholder="Specify date range" />
        </div>
        <!-- /date -->

        <div class="dropdown mb-2">
          <input type="hidden" :value="filterEmail" id="email_lookup" />
          <span class="glyphicons glyphicons-filter mt-0 input-icon-left text-muted"></span>
          <input type="text" 
            id="txt_filter2"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="form-control material-control icon-right" 
            autocomplete="off" :value="filterCampaignDisplayText" 
            placeholder="Campaign filters" 
            @keyup.delete="function() {search.filterCampaign=null; search.filterCampaignType=null;}" 
            readonly
          />
          <ul class="dropdown-menu">
            <li class="dropdown-item"
              @click="search.filterCampaign=null; search.filterCampaignType=null"
              :class="{'active': search.filterCampaign==null && search.filterCampaignType==null}"
              >No Filter</li>
            <li role="separator" class="dropdown-divider"></li>
            <div class="dropdown-group" style="max-height: calc(100vh - 200px)">
              <li class="dropdown-header">Campaign Type</li>
              <li class="dropdown-item"
                @click="search.filterCampaignType='purpose'; search.filterCampaign='Promotional';"
                :class="{'active': search.filterCampaign=='Promotional' && search.filterCampaignType=='purpose'}"
                >Promotional</li>
              <li class="dropdown-item"
                @click="search.filterCampaignType='purpose'; search.filterCampaign='Transactional';"
                :class="{'active': search.filterCampaign=='Transactional' && search.filterCampaignType=='purpose'}"
                >Transactional</li>
              <template v-if="marketingPrograms.length">
                <li role="separator" class="dropdown-divider"></li>
                <li class="dropdown-header">Marketing Program</li>
                <li
                  class="dropdown-item"
                  v-for="(item,idx) in marketingPrograms"
                  @click="search.filterCampaignType='marketing_program'; search.filterCampaign=item;"
                  :class="{'active': search.filterCampaign==item && search.filterCampaignType=='marketing_program'}"
                >
                  {{item}}
                </li>
              </template>
              <template v-if="marketingStrategies.length">
                <li role="separator" class="dropdown-divider"></li>
                <li class="dropdown-header">Marketing Strategy</li>
                <li
                  class="dropdown-item"
                  v-for="(item,idx) in marketingStrategies"
                  @click="search.filterCampaignType='marketing_strategy'; search.filterCampaign=item;"
                  :class="{'active': search.filterCampaign==item && search.filterCampaignType=='marketing_strategy'}"
                >
                  {{item}}
                </li>
              </template>
            </div>
          </ul>

        </div>

        <div class="mt-2 d-md-none">
          <div class="custom-control custom-switch d-inline-block">
            <input type="checkbox" class="custom-control-input" id="chkJourney2" v-model="viewJourney">
            <label class="custom-control-label" for="chkJourney2">Show Customer Journey</label>
          </div>                        
        </div>

        <div class="mt-4" style="text-align:right;">
          <a href="#" class="text-secondary mr-2" @click="function() {resetSearch();closeFilterPane()}">Reset all filters</a>
          <button class="btn btn-sm btn-primary" @click.prevent="function(){doSearch();closeFilterPane()}">Search</button>
        </div>
      </form>
    </div>
  </div>

    <div id="divDefaultStatus" v-if="defaultStatusText && !filterPaneVisible" class="small container-fluid text-secondary fade-in justify-content-start" style="margin-bottom: -5px;">{{defaultStatusText}}&nbsp;&nbsp;|&nbsp;&nbsp;
      <a href="#" @click="resetSearch">Clear</a> 
      <!--<a href="#" @click="clearDefaultSearch" class="ml-2">Remove default search</a>-->
    </div>
  </nav>  
</div>

</template>
<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import {mapState} from 'vuex'
const findIndex = require('lodash/findIndex')
const uniq = require('lodash/uniq')
import DateFormatting from '@/mixins/date-formatting'
import SearchBar from '@/mixins/search-bar'
import {getLocalStorage} from '@/js/sageflo/ui-helpers.js'

export default {
  mixins: [DateFormatting,SearchBar],
  data: function() {return {
    searchTypeIndex: 0,
    lastSearchWasAdvanced: false,
    overrideFields: {},
    defaultSearch: false,
    defaultStatusText: null,
    search: {
      startDate: null,
      endDate: null,
      subject_keywords: null,
      filterDateRange: '',
      filterMobile: null,
      filterCampaign: null,
      filterCampaignType: null,
      filterDropdownItem: {
        id: null,
        type: 'standard'
      },
      filterDropDownInputText: ''
    },
    filterDropDownItems: [
      {
        id: 'subject_keywords',
        displayName: 'Subject Line',
        type: 'standard',
        config: {},
      },
      {
        id: 'campaign_name',
        displayName: 'Campaign Name',
        type: 'standard',
        config: {},
      }
    ],
    moreFilters: {
      subject_keywords: {value: null},
      campaign_name: {value: null},
      purpose: {value: null},
      platform_campaign_id: {value: null},
      marketing_program: {value: null},
      marketing_strategy: {value: null},
      from_email: {value: null},
      from_name_keywords: {value: null},
    },
    viewJourney: false,
    isAdvancedPrimarySearch: false,
    hasAlternateKeys: false,
    filterPaneVisible: false,
    currentPersona: {}
  }},
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeAccountIndex: (state)=>state.ui.activeAccountIndex,
      activeSubAccount: (state)=>state.ui.activeSubAccount,      
      viewType: (state)=>state.ui.viewType,
      navbarCollapsed: (state)=>state.ui.navbarCollapsed,
      selectedEmail: (state)=>state.search.selectedEmail, 
      personas: (state)=>state.search.personas, 
      filterEmail: (state)=>state.search.filterEmail,
      filterMobile: (state)=>state.search.filterMobile,
      resultsKey: (state)=>state.search.resultsKey,
      qsParams: (state)=>state.search.qsParams,
    }),
    filterDropDownDisplayText: function() {
      if (this.search.filterDropdownItem.id){
        let ret = this.search.filterDropdownItem.displayName;
        if (this.search.filterDropdownItem.type == 'standard') {
          ret += ' keywords';
        }
        return ret;
      } else {
        this.search.filterDropdownItem.id = 'subject_keywords';
        this.search.filterDropdownItem.displayName = 'Subject Line';
        return 'Subject Line keywords';
      }
    },
    filterCampaignDisplayText: function() {
      if (!this.showPlatformFields.filterCampaign) {
        return '(Filters Disabled)';
      } else if (this.search.filterCampaignType==null) {
        return '';
      } else {
        return this.search.filterCampaign;
      }
    },
    personasEnabled: function() {
      let enabled = Boolean(this.uiConfig.account && (!this.uiConfig.account.config.personas_disabled));

      if (enabled) {
        this.$store.dispatch("fetchPersonas");
      }

      return enabled;
    },
    emailSearchDisabled: function() {
      return Boolean(this.uiConfig.account && (!this.uiConfig.account.config.email_search_disabled));      
    },
    personasPlus() {
      return Boolean(this.personasEnabled && !this.emailSearchDisabled);
    },
    personaActive() {
      return Boolean(Object.keys(this.currentPersona).length>0);
    },
    emailZipDownloadEnabled: function() {
      return (this.privs && this.privs.EZ && this.uiConfig.account 
        && this.uiConfig.account.config.email_zip_download_enabled);
    },
    suppressSearchTextBox: function() {
      return Boolean(this.qsParams && this.qsParams.simpleSearch);
    },
    hasChannelSearchType: function() {
      if (this.searchTypes.length > 0) {
        return Boolean(this[this.searchTypes[this.searchTypeIndex].filterParameter]);
      } else {
        return false;
      }
    },
    isPrimarySearch: function() {
      return this.search.filterDropdownItem.method=='PRIMARY' || this.search.filterDropdownItem.method=='INDEPENDENT';
    },
    recordsLength: function() {
      return this.emails.length;
    },
    fromEmails: function() {

      if (this.uiConfig.from_emails) {

        if (this.activeSubAccount) {
          if (this.uiConfig.from_emails[this.activeSubAccount.sub_account_name]) {
            return uniq(this.uiConfig.from_emails[this.activeSubAccount.sub_account_name]).sort();
          } else {
            return [];
          }
        } else {
          return uniq(this.uiConfig.from_emails['ALL']).sort();
        }
      } else {
        return [];
      }
    },
    marketingPrograms: function() {
      if (this.uiConfig.marketing_programs) {
        if (this.activeSubAccount) {
          if (this.uiConfig.marketing_programs[this.activeSubAccount.sub_account_name]) {
            return uniq(this.uiConfig.marketing_programs[this.activeSubAccount.sub_account_name]).sort();
          } else {
            return [];
          }
        } else {
          return uniq(this.uiConfig.marketing_programs['ALL']).sort();
        }
      } else {
        return [];
      }
    },
    minimumDate: function() {
      let createDate = moment();
      if (this.activeSubAccount) {
        console.log('here')
        createDate = moment(this.activeSubAccount.created_dt);
        if (this.activeSubAccount.start_dt){
          //if start_dt exists, then it should take precidence over create-dt
          createDate = moment(this.activeSubAccount.start_dt)
        }
        //if now - storage months is after createDate, then the minimum date should be now - storage months
        if (this.activeSubAccount.storage_months!=-1 && this.activeSubAccount.storage_months!=null && moment().subtract(this.activeSubAccount.storage_months, 'months').isAfter(createDate) ) {
          createDate = moment().subtract(this.activeSubAccount.storage_months, 'months');
        }

      } else if (this.uiConfig.sub_accounts) {

        for (let subAccount of this.uiConfig.sub_accounts) {
          let newCreateDate = moment(subAccount.created_dt);
          if (subAccount.start_dt){
            //if start_dt exists, then it should take presidence over created_dt
            newCreateDate = moment(subAccount.start_dt)
          }
          if (subAccount.storage_months!=-1 && subAccount.storage_months!=null && newCreateDate.isBefore(moment().subtract(subAccount.storage_months,'months'))) {
            newCreateDate = moment().subtract(subAccount.storage_months,'months');
          }

          if (newCreateDate.isBefore(createDate)) {            
            createDate = newCreateDate;
          }

        }
        
      }
      return createDate;

    },
    showPlatformFields: function() {
      let fields = {};
      let platforms = ['Responsys','Demo'];
      let platformFields = {
        Responsys: {
          filterCampaign: true,
          purpose: true,
          marketing_strategy: true,
          marketing_program: true,
          platform_campaign_id: true
        },
        Demo: {
          filterCampaign: true,
          purpose: true,
          marketing_strategy: true,
          marketing_program: true,
          platform_campaign_id: true
        }

      }

      if (this.activeSubAccount) {
        for (let platform of platforms) {
          if (this.activeSubAccount.source_type == platform) {
            Object.assign(fields, platformFields[platform]);  
          }
        }
      } else if (this.uiConfig.sub_accounts) {
        for (let platform of platforms) {
          let idx = findIndex(this.uiConfig.sub_accounts, function(o) { return o.source_type == platform })
          if (idx != -1) {
            Object.assign(fields, platformFields[platform])
          }
        }
        
      }
      return fields;
    },
    marketingStrategies: function() {
      if (this.uiConfig.marketing_strategies) {
        if (this.activeSubAccount) {
          if (this.uiConfig.marketing_strategies[this.activeSubAccount.sub_account_name]) {
            return uniq(this.uiConfig.marketing_strategies[this.activeSubAccount.sub_account_name]).sort();
          } else {
            return [];
          }
        } else {
          return uniq(this.uiConfig.marketing_strategies['ALL']).sort();
        }
      } else {
        return [];
      }

    },
    advancedFilters: function() {
      var fields = [];
      this.hasAlternateKeys = false;
      function createInputCss(field){
        let css  = {};
        if (field.config.input_option){
          //We could set "text-transform" with the input_option value, but that seems brittle to me
          if (field.config.input_option == "lowercase"){
            css["text-transform"] = "lowercase";
          } else if (field.config.input_option == "uppercase"){
            css["text-transform"] = "uppercase";
          }
        }
        return css;
      }
      if (this.uiConfig.custom_fields || this.uiConfig.metadata_fields) {
        for (let idx in this.uiConfig.custom_fields) {
          // todo add to top level search filters object
          var mdField = this.uiConfig.custom_fields[idx];
          var currentSearchType = (this.searchTypes[this.searchTypeIndex].value=='email') ? 'mail' : this.searchTypes[this.searchTypeIndex].value;

          if (mdField.category==currentSearchType) {
            if (mdField.type == 'OVERRIDE') {
              this.overrideFields[mdField.id] = true;
            }

            if (mdField.search_method=="PRIMARY" || mdField.search_method=="INDEPENDENT") {
              this.hasAlternateKeys = true;
            }
            let field ={
              id: mdField.name,
              name: mdField.name,
              column_name: mdField.column_name,
              requireEmail: mdField.search_method == 'DEPENDENT', 
              displayName: mdField.display_name,
              method: mdField.search_method,
              has_options: mdField.has_options,
              options: mdField.has_options ? mdField.options : false,
              type: 'custom',
              config: mdField.config,
            }
            field.inputCss = createInputCss(mdField)
            fields.push(field);
            this.$set(this.moreFilters,mdField.name, Object.assign({value: null},field));
          } 
        }

        for (let idx in this.uiConfig.metadata_fields) {
          // todo add to top level search filters object

          var mdField = this.uiConfig.metadata_fields[idx];

          if (mdField.search_method!='NONE' && mdField.category==currentSearchType) {
            if (mdField.name == 'campaign_name') {
              this.overrideFields['campaign_name'] = true;
            }
            let field = {
              id: mdField.name,
              name: mdField.name,
              column_name: mdField.column_name,
              requireEmail: true, 
              displayName: mdField.display_name,
              method: mdField.search_method,
              type: 'metadata',
              config: mdField.config,
            }
            field.inputCss = createInputCss(mdField)
            fields.push(field);
            this.$set(this.moreFilters,mdField.name, Object.assign({value: null},field));
            console.log(mdField.name)
          }
        }
      }
      return fields;
    },
    lookupKeyHelpText: function() {
      return `Instead of ${this.searchTypes[this.searchTypeIndex].displayName} as the primary lookup key, you may use an alternate lookup key. Alternate lookup keys follow these rules:<br><br>
        <span class="text-success glyphicons glyphicons-message-plus mr-1"></span> <span class="font-weight-semibold">${this.searchTypes[this.searchTypeIndex].displayName} is Optional</span><br>
        When using this type of alternate lookup key, ${this.searchTypes[this.searchTypeIndex].displayName} can be included as a search value, but is not a required field.<br><br>
        <span class="text-warning glyphicons glyphicons-message-ban mr-1"></span> <span class="font-weight-semibold">Other Values Ignored</span><br>
        When using this type of alternate lookup key, all other filter values (including ${this.searchTypes[this.searchTypeIndex].displayName} and dates) will be ignored.`;
    },
    isSelectedEmail(){
      return (this.selectedEmail != null && this.selectedEmail.uuid != null); 
    }
  },
  created: function() {
    this.$store.dispatch("fetchPersonas");
  },
  mounted: function() {
    let that = this;

    this.search.startDate = moment().subtract(29, 'days');
    this.search.endDate = moment();

    $("#filterPane").on('hide.bs.collapse',function () {
      that.filterPaneVisible = false;
      //$(document.getElementById('frmFilterPane')).removeClass('was-validated');
    });

    $("#filterPane").on('show.bs.collapse', function () {
      that.setupFilterPane();
    });

    $("#filterPane").on('shown.bs.collapse', function () {
      // blinks any textboxes with values
      $('#filterPane input[type=text]').each(function(){
        if (($(this).val())) {
          $(this).delay(150).fadeOut(150).fadeIn(200);
        }
      });
    });
    
    $('#searchBar').popover({
      //find any elements that have something in data-content
      selector: '[data-toggle="popover"]',
      container: 'body',
      delay: { "show": 500, "hide": 100 },
      html: true,
      trigger: 'hover',
      boundary: 'viewport',
    });

    $('#searchBar').tooltip({selector: '[data-toggle="tooltip"]', html:true, trigger: 'hover', delay: { "show": 500, "hide": 100 }});

    $(document).on('keydown', function(event) {
     if (event.key == "Escape") {
       if (that.filterPaneVisible) {
        that.closeFilterPane()
       }
     }
    });

    $(document).on('click', function(event) {
      that.closeFilterPane(event)
    })
  },
  updated: function() {
    let that = this

    $('.date-filter-control').daterangepicker({
      singleDatePicker: false,
      minDate: this.minimumDate,
      startDate: this.search.startDate,
      endDate: this.search.endDate,
      timePicker: false,
      autoApply: false,
      autoUpdateInput: true,
      locale: { format: 'M/D/YY' },
      ranges: {
         'Today': [moment(), moment()],
         'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
         'Last 7 Days': [moment().subtract(6, 'days'), moment()],
         'Last 30 Days': [moment().subtract(29, 'days'), moment()],
         'Last 90 Days': [moment().subtract(89, 'days'), moment()],
         'Last 180 Days': [moment().subtract(179, 'days'), moment()]        
       }
    },(start,end,label)=>{ 
      that.search.startDate = start;
      that.search.endDate = end;

      if (that.personaActive) {
        that.doSearch()
      }
    });

      //$('#date_filter').data('daterangepicker').setStartDate(this.search.startDate);
      //$('#date_filter').data('daterangepicker').setEndDate(this.search.endDate);
  },
  methods:{
    doSearch(isAdvancedSearch){
      isAdvancedSearch = (isAdvancedSearch)?true:false;
      console.log(`doSearch ${(isAdvancedSearch) ? '- is advanced' : ''}`)
      
      let params = {}
      
      if (this.currentPersona.lookup_email) {
        params.email = this.currentPersona.lookup_email;
        this.invalidPersona = false;
      } else {
        console.log(this.currentPersona)
        this.invalidPersona = true;
        return;
      }
      params.persona_search = true;
      params.advanced_search = isAdvancedSearch;
      params.start_date = this.search.startDate.format("M/D/YYYY");
      params.end_date = this.search.endDate.format("M/D/YYYY");
      
      function processInputOption(inputOption,value){
        if (inputOption && value){
          if (inputOption == "uppercase"){
            return value.toUpperCase();
          } else if (inputOption == "lowercase"){
            return value.toLowerCase();
          } else {
            return value;
          }
        } else {
          return value;
        }
      }


      // validate simple searchbar form        
      if (this.search.subject_keywords) {
        params['subject_keywords'] = this.search.subject_keywords;
      }

      if (this.search.filterCampaign && this.showPlatformFields.filterCampaign) {
        if (this.search.filterCampaignType=='purpose') { // need to convert value to Uppercase for purpose
          params[this.search.filterCampaignType] = this.search.filterCampaign.toUpperCase();
        } else {
          params[this.search.filterCampaignType] = this.search.filterCampaign;  
        }
      }

      if (this.activeSubAccount!=null) {
        params.sub_account=this.activeSubAccount.sub_account_name;
      }
      console.log(params);

      this.$store.dispatch("searchEmails",params);
      
    },
    clearSearchResults() {
      this.$store.dispatch("searchEmails",{});
    },
    setPersona(item) {
      this.currentPersona=item;
      $('#txt_persona').focus();
      this.doSearch();
    },
    clearPersona() {
      this.currentPersona = {};
      this.clearSearchResults();
    },
    resetSearch() {
      this.$store.commit("setFilterEmail",null);
      this.$store.commit("setFilterMobile",null);
      this.clearPersona();
      this.search.filterDropDownInputText = null;
      this.search.filterCampaign=null; 
      this.search.filterCampaignType=null;
      this.search.subject_keywords=null;
      this.search.startDate = moment().subtract(29, 'days');
      this.search.endDate = moment();

      $('.date-filter-control').data('daterangepicker').setStartDate(this.search.startDate);
      $('.date-filter-control').data('daterangepicker').setEndDate(this.search.endDate);

      this.defaultStatusText = null;

    },
    saveDefaultSearch() {
      let defaultSearch = {
        searchTypeIndex: this.searchTypeIndex,
        primeSearchValue: this[this.searchTypes[this.searchTypeIndex].filterParameter],
        filterDropDownInputText: this.search.filterDropDownInputText,
        filterDropdownItemId: this.search.filterDropdownItem.id,
        filterCampaign: this.search.filterCampaign,
        filterCampaignType: this.search.filterCampaignType
      }

      let storageKey = this.uiConfig.user_email + 'settings';
      localStorage.setItem(storageKey,JSON.stringify(defaultSearch));
      this.defaultSearch = JSON.stringify(defaultSearch);
    },
    applyDefaultSearch() {
      let settings = this.defaultSearch;
      if (settings) {
        settings = JSON.parse(settings);

        this.searchTypeIndex = settings.searchTypeIndex;
        
        if (this.searchTypes[this.searchTypeIndex].value=='email') {
          this.$store.commit("setFilterEmail",settings.primeSearchValue);
        } else if (this.searchTypes[this.searchTypeIndex].value=='sms') {
          this.$store.commit("setFilterMobile",settings.primeSearchValue);
        }
        this.search.filterDropDownInputText = settings.filterDropDownInputText;

        let idx = findIndex(this.filterDropDownItems,{id: settings.filterDropdownItemId}) // check standard filters first
        if (idx==-1) {
          idx = findIndex(this.advancedFilters,{id: settings.filterDropdownItemId}) // next check advanced filters if we didn't find a match
          if (idx!=-1) this.search.filterDropdownItem=this.advancedFilters[idx];
        } else {
          this.search.filterDropdownItem=this.filterDropDownItems[idx]
        }
        
        this.search.filterCampaign = settings.filterCampaign;
        this.search.filterCampaignType = settings.filterCampaignType;

        this.$nextTick(()=>{this.defaultStatusText = 'Currently using default search values'});
      } else {
        this.defaultStatusText = null;
      }
    },
    clearDefaultSearch() {
      this.defaultSearch = null;
      let storageKey = this.uiConfig.user_email + 'settings';
      localStorage.removeItem(storageKey);
      this.defaultStatusText = null;
    },
    resetFilters() {
      this.$store.commit("setFilterEmail",null);
      this.$store.commit("setFilterMobile",null);

      // reset all advanced filters
      for (let key in this.moreFilters) {
        this.moreFilters[key].value = null;
      }
      this.defaultStatusText = null;
    },
    setViewType(viewType){
      localStorage.setItem("viewMode",viewType);
      this.$store.commit("setViewType",viewType);
    },
    closeFilterPane(evt) {

      if (evt && !$.contains(document.getElementById('filterPane'),evt.target)) {
        $('#filterPane').collapse('hide');
      } else if (!evt) {
        $('#filterPane').collapse('hide');
      }

    },
    setupFilterPane() {
      this.filterPaneVisible = true;
      /*$('#pageMasker').fadeIn(500,'swing').removeClass('d-none');

      $(document.getElementById('frmFilters')).removeClass('was-validated');*/

      // hide any tooltips
      $('[data-toggle="tooltip"]').tooltip('hide');

      // populate value based on filter dropdown setting
      /*if (this.search.filterDropdownItem.id!=null && this.search.filterDropDownInputText) {
        console.log(this.search.filterDropdownItem.id);
        this.moreFilters[this.search.filterDropdownItem.id].value = this.search.filterDropDownInputText
      }*/
    },
    async downloadEmails(){
     this.$eventBus.$emit("showStatus",{
        msg:`Beginning email download. This may take up to a minute or more.`,
        title: `Beginning email download`,
      });
      fetch(`/api/v1/email/zip?email=${this.filterEmail}`)
        .then(async response => {
          if (!response.ok){
            let result = await response.json();
            let msg = null;
            let title = null;
            if (response.status == 401){
              window.location.href = "/login";
              return;
            } else if (response.status == 404) {
              msg = `No emails were found for ${this.filterEmail}`;
              title = "Not found";
            } else {
              msg = `Download error. Status:${response.status} Error: ${result.message}`;
              title = "Unexpected Error";
            }
            this.$eventBus.$emit("showStatus",{
              msg: msg,
              title: title,
              isWarning: true,
            });
          } else {
            //This roundabout and way of downloading the file is so that we can use
            //fetch and check the response for failure/emails not found
            //What this does is download the file, creates a blob,
            //and then creates a link using the blob and clicks the link so it downloads.
            //Then it cleans up the link.          
            let blob = await response.blob()
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename
            a.download = `${this.filterEmail}_emails.zip`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.$eventBus.$emit("showStatus",{
              msg:`Emails download complete.`,
              title: `Download complete`,
            });
          }
        })
        .catch((err) => {
          this.$eventBus.$emit("showStatus",{
            msg: `Unexpected error: ${err}`,
            title: "Unexpected error",
            isWarning: true,
          });
        });
    }
  },
  watch: {
    viewJourney: {
      handler: function(newVal) {
        if (newVal) {
          this.setViewType('journey')
        } else {
          this.setViewType('list')
        }
      }
    },
    viewType: {
      handler: function(newVal) {
        this.viewJourney = (newVal=='journey') ? true : false
      },
      immediate: true
    },
    'search.filterDropDownInputText': {
      handler: function() {
        this.defaultStatusText = null;
      },
      immediate: true      
    },
    'search.filterCampaign': {
      handler: function(newVal) {
        if (this.personaActive) {
          this.doSearch();
        }
        this.defaultStatusText = null;
      },
      immediate: true      
    },
    'moreFilters': {
      handler: function(newVal) {
        this.defaultStatusText = null;
      },
      immediate: true
    },
    'filterMobile': {
      handler: function(newVal) {
        this.defaultStatusText = null;
      },
      immediate: true
    },
    'filterEmail': {
      handler: function(newVal) {
        this.defaultStatusText = null;
      },
      immediate: true
    },
    'uiConfig': {
      handler: function(newVal) {
        let storageKey = newVal.user_email + 'settings';
        this.defaultSearch = getLocalStorage(storageKey,false);
      },
      immediate: true
    },
    'searchTypeIndex': function(newVal) {
      this.search.filterDropDownInputText = null;
      let idx = -1;

      // make sure, if there is a selected filterType, that it still exists in dropdown list
      if (this.searchTypes[newVal].value=='sms') {
        idx = findIndex(this.filterDropDownItems, function(o) { return o.id == "campaign_name" });        
      } else {
        idx = findIndex(this.filterDropDownItems, function(o) { return o.id == "subject_keywords" });
      }
      if (idx!=-1) {
        this.search.filterDropdownItem = this.filterDropDownItems[idx];
      }
    },
    'advancedFilters': function(advancedFilters){
      let qsParams = this.qsParams;
      console.log("Advanced filters changed, qsParams: ", qsParams)
      //not sure what to do about this exactly. Basically just checking
      //if only qs parameter is token, in which case don't set up the search, etc.
      //before this, search would happen when only qs param is token, which is undesirable.
      let doSearch = false;
      if (qsParams){
        let qsKeys = Object.keys(qsParams);
        if (qsKeys.length == 1 && qsKeys[0] == "token"){
          doSearch = false;
        } else {
          doSearch = true;
        }
      }
      if (doSearch){
        if (qsParams.searchEmail){
          this.$store.commit("setFilterEmail",qsParams.searchEmail);
        }
        if (qsParams.startDate){
          this.search.startDate = moment(qsParams.startDate,"M/D/YYYY");
        }
        if (qsParams.endDate){
          this.search.endDate = moment(qsParams.endDate,"M/D/YYYY");
        }
        if (qsParams.filterSubject || qsParams.filterType){
          let filterName = qsParams.filterType;
          let filterValue = qsParams.filterSubject;
          if (filterValue && !filterName){
            //just subject line
            this.search.filterDropdownItem = find(this.filterDropdownItems,{id: "subject_keywords"});
            this.search.filterDropDownInputText = filterValue;
          } else {
            let filter = this.moreFilters[filterName];
            if (filter){
              this.search.filterDropdownItem = filter;
              this.search.filterDropDownInputText = filterValue;
            } else {
              console.log("Filter not found: " + filterName)
            }
          }
        }
        //do search after UI updates
        Vue.nextTick(()=>{
          this.doSearch(false);
        });
      } else {
        this.applyDefaultSearch(); // populate default search values in fields 
      }
    },
  }
}

</script>

<style scoped>
hr {
  width:  100%;
}

select.custom-select-sm {
  font-size: 100%;
  padding-bottom: .1rem;
  padding-top: .1rem;
}


select.custom-select-sm:focus {
  border-color: var(--cyan);
  box-shadow: 0 0 0 0.2rem rgba(63,175,204,.25);
}

input::placeholder {
  font-size: 13px;
}

input.form-control-sm {
  min-height: 31px;
}

input#txt_persona[readonly] {
  background-color: var(--white);
}

.input-group input.last-in-group {
  border-top-right-radius: .2rem !important;
  border-bottom-right-radius: .2rem !important;
}

.control-group-tight {
  max-width: 165px;
}

.disabled-dropdown-item{
  cursor:not-allowed;
  background-color: white;
}

.submenu-item {
  position: relative;
}

.form-control.material-control {
  height: calc(2em);
  border: none;
  border-bottom: 1px solid #ccc5cd;
  border-radius: 0;
  background-color: transparent!important;
}

.form-control.material-control:focus{
  border-bottom: 1px solid var(--indigo);
  outline: 0;
  box-shadow: none;
}


.form-control.primary-control::placeholder, 
.form-control.tiny-nav-btn:placeholder {
    font-weight: normal;
    font-size: .9em;
}

.form-control.material-control::placeholder {
    font-size: .9em;  
}

.form-control.primary-control {
  height: calc(2em);
  border: 1px solid transparent;
  border-radius: 1rem;
  background-color: rgba(100,100,100,.1) !important;  
}

.form-control.primary-control:focus{
  border: 1px solid #a4d9e7;
  outline: 0;
}

.input-icon-left {
  position: absolute;
  top: 4px;
  left: 6px;
  pointer-events: none;
}

.input-icon-right {
  position: absolute;
  top: 4px;
  right: 8px;
  pointer-events: none;
}

.material-control.icon-right, .primary-control.icon-right {
  padding-right: 25px;
}

.input-icon-left + .material-control, .input-icon-left + .tiny-nav-btn {
  padding-left: 23px;
  width: 100%;
}

.form-control.tiny-nav-btn {
  height: 1.5rem;
  border: 2px solid #e3f5fa;
  background-color: #e3f5fa;
  border-radius: .75rem;
  font-size: .8rem;
  width: 150px;
  min-width: 150px;
  padding-right: 2px;
}

.form-control.tiny-nav-btn:hover {
  background-color: var(--cyan);
  border-color: var(--cyan);
}

.input-icon-left + .primary-control {
  padding-left: 30px;
  width: 100%;
}

.btn-reset {
  position: absolute;
  top: 2px;
  right: 32px;
  width: 28px;
  text-align: center;
  padding: .2rem;
  cursor:  pointer;
  color: var(--gray);
  background-color: transparent;
}

.btn-reset:hover {
  background-color: var(--gray);
  border-radius: 1rem;
  color: var(--light);
}

.btn-filter {
  position: absolute;
  top: 2px;
  right: 5px;
  padding: .2rem;
  cursor:  pointer;
  color: var(--gray);
}

.btn-filter:hover {
  border-radius: 1rem;
  color: var(--light);
  background-color: var(--gray);
  /*background-color: var(--cyan);
  color: var(--indigo);*/
}

.secondary-navbar-light {
  top: 0px;
  background: transparent;
  box-shadow:  none;
}

#personaSearchPanel {
  position: absolute; 
  top: 6px; 
  left: 260px !important;
  width: calc(100vw - 300px);
  z-index: 1050;
}

.hoverShow {
  display:  none;
}

#filterPane {
  position: absolute;
  width: 250px;
  left: 260px !important;
  z-index: 1000;
}

#filterPaneChild {
  position: relative;
  background-color: var(--light);
  border: 1px solid rgba(0,0,0,.15);
  border-radius: .25rem;
  /*box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);*/
}
</style>